// import Axios  from './axios'
import {post, get, put, destroy, upload} from './axios'
import Axios from "axios";

/**
 * 资源管理接口
 * @returns {Promise<T>}
 */
//获取考试项目
export const getSubjects = (params) => {
  return get('/subjects', params).then(res => res.data);
}
//获取考试项目
export const getSubject = (id, params) => {
  return get('/subjects/' + id, params).then(res => res.data);
}
//新增考试项目
export const addSubject = (params) => {
  return post('/subjects', params).then(res => res.data);
}
//修改考试项目
export const updateSubject = (id, params) => {
  return put('/subjects/' + id, params).then(res => res.data);
}
//删除用物
export const deleteSubject = (id) => {
  return destroy('/subjects/' + id,).then(res => res.data);
}
//修改病例
export const updateCase = (id, params) => {
  return put('/cases/' + id, params).then(res => res.data);
}
//获取病例
export const getCases = (params) => {
  return get('/cases', params).then(res => res.data);
}
//获取病例
export const getCase = (id) => {
  return get('/cases/' + id,).then(res => res.data);
}
//删除病例
export const deleteCase = (id) => {
  return destroy('/cases/' + id,).then(res => res.data);
}
//新增病例
export const addCase = (params) => {
  return post('/cases', params).then(res => res.data);
}//获取用物
export const getSupplies = (params) => {
  return get('/supplies', params).then(res => res.data);
}
//获取用物
export const getSupply = (id) => {
  return get('/supplies/' + id).then(res => res.data);
}
//新增用物
export const addSupply = (params) => {
  return post('/supplies', params).then(res => res.data);
}
//修改用物
export const updateSupply = (id, params) => {
  return put('/supplies/' + id, params).then(res => res.data);
}
//删除用物
export const deleteSupply = (id) => {
  return destroy('/supplies/' + id,).then(res => res.data);
}
//获取老师
export const getTeachers = (params) => {
  return get('/teachers', params).then(res => res.data);
}
//获取老师
export const getTeacher = (id, params) => {
  return get('/teachers/' + id, params).then(res => res.data);
}
//新增老师
export const addTeacher = (params) => {
  return post('/teachers', params).then(res => res.data);
}
//修改老师
export const updateTeacher = (id, params) => {
  return put('/teachers/' + id, params).then(res => res.data);
}
//删除老师
export const deleteTeacher = (id) => {
  return destroy('/teachers/' + id,).then(res => res.data);
}
//导入老师
export const importTeacher = (params) => {
  return upload('/importTeacher', params).then(res => res.data);
}

//获取设备
export const getVcrs = (params) => {
  return get('/vcrs', params).then(res => res.data);
}
//获取设备
export const getVcr = (id, params) => {
  return get('/vcrs/' + id, params).then(res => res.data);
}
//新增设备
export const addVcr = (params) => {
  return post('/vcrs', params).then(res => res.data);
}
//修改设备
export const updateVcr = (id, params) => {
  return put('/vcrs/' + id, params).then(res => res.data);
}
//删除设备
export const deleteVcr = (id) => {
  return destroy('/vcrs/' + id,).then(res => res.data);
}
//获取房间
export const getRooms = (params) => {
  return get('/rooms', params).then(res => res.data);
}
//获取房间
export const getRoom = (id, params) => {
  return get('/rooms/' + id, params).then(res => res.data);
}
//新增房间
export const addRoom = (params) => {
  return post('/rooms', params).then(res => res.data);
}
//修改房间
export const updateRoom = (id, params) => {
  return put('/rooms/' + id, params).then(res => res.data);
}
//删除房间
export const deleteRoom = (id) => {
  return destroy('/rooms/' + id,).then(res => res.data);
}

//获取考站
export const getStations = (params) => {
  return get('/stations', params).then(res => res.data);
}
//获取考站
export const getStation = (id, params) => {
  return get('/stations/' + id, params).then(res => res.data);
}
//新增考站
export const addStation = (params) => {
  return post('/stations', params).then(res => res.data);
}
//修改考站
export const updateStation = (id, params) => {
  return put('/stations/' + id, params).then(res => res.data);
}
//删除考站
export const deleteStation = (id) => {
  return destroy('/stations/' + id,).then(res => res.data);
}

///////////////////////////////////////////////
//用户信息
export const getUserInfo = () => {
  return get('/user').then(res => res.data);
}
// 登录
export const userLogin = (params) => {

  return post('/authorizations', params).then(res => res.data);
}
// 今日考试
export const todayExam = (params) => {

  return get('/exam/today', params).then(res => res.data);
}
// 开始考试
export const setBegin = (params) => {

  return get('/exam/set-begin', params).then(res => res.data);
}
// 考试安排列表
export const examsList = (params) => {

  return get('/exams', params).then(res => res.data);
}
//新增考试
export const addExam = (params) => {

  return post('/exams', params).then(res => res.data);
}
//考试详情
export const examDetails = (id) => {

  return get('/exams/' + id).then(res => res.data);
}
//考生查询
export const getExamStudents = (params) => {

  return get('/exam/students', params).then(res => res.data);
}
//考生查询
export const getExamStudent = (id, params) => {

  return get('/students/' + id, params).then(res => res.data);
}
//成绩查询
export const getExamResults = (params) => {

  return get('/exam-results/list', params).then(res => res.data);
}
//成绩详情
export const getExamResult = (params) => {

  return get('/exam-results/list', params).then(res => res.data);
}
//成绩详情
export const getExamResultStations = (params) => {

  return get('/exam-results/stations', params).then(res => res.data);
}
//资讯列表
export const getNotices = (params) => {

  return get('/notices', params).then(res => res.data);
}

//获取资讯
export const getNotice = (id, params) => {
  return get('/notices/' + id, params).then(res => res.data);
}
//新增资讯
export const addNotice = (params) => {
  return post('/notices', params).then(res => res.data);
}
//修改资讯
export const updateNotice = (id, params) => {
  return put('/notices/' + id, params).then(res => res.data);
}
//删除资讯
export const deleteNotice = (id) => {
  return destroy('/notices/' + id,).then(res => res.data);
}
//所有考试
export const getAllExam = (params) => {
  return get('/getAllExam', params).then(res => res.data);
}
//缺考统计
export const getExamMiss = (params) => {
  return get('/exam/un-sign-list', params).then(res => res.data);
}
//获取考站
export const stationList = (params) => {

  return get('/exam-arrange/station-list', params).then(res => res.data);
}
//获取考站
export const stationSubjects = (params) => {

  return get('/exam-arrange/station-subject', params).then(res => res.data);
}
//获取考试的所有阶段
export const allGradations = (params) => {

  return get('/exam-arrange/all-gradations', params).then(res => res.data);
}
//获取考试项目
export const allSubjects = (params) => {

  return get('/exam-arrange/all-subjects', params).then(res => res.data);
}
//获取考场接口
export const roomList = (params) => {

  return get('/exam-arrange/room-list', params).then(res => res.data);
}
//新增考站
export const addExamFlow = (params) => {

  return post('/exam-arrange/add-exam-flow', params).then(res => res.data);
}
//获取考试安排数据的回显
export const examArrangedata = (params) => {

  return get('/exam-arrange/exam-arrange-data', params).then(res => res.data);
}
//新增大站下面小站
export const addExamDraft = (params) => {

  return post('/exam-arrange/add-exam-draft', params).then(res => res.data);
}
//保存考试安排
export const arrangeSave = (params) => {

  return post('/exam-arrange/arrange-save', params).then(res => res.data);
}
//删除考站
export const delExamflow = (params) => {

  return get('/exam-arrange/del-exam-flow', params).then(res => res.data);
}
//删除大站下面的小站
export const delExamdraft = (params) => {

  return get('/exam-arrange/del-exam-draft', params).then(res => res.data);
}
//获取考官安排
export const examTeacherarrange = (params) => {

  return get('/exam-arrange/exam-teacher-arrange', params).then(res => res.data);
}
//根据考试项目 获取对应下的考官（接口）
export const invigilatesbysubject = (params) => {

  return get('/exam-arrange/invigilates-by-subject', params).then(res => res.data);
}

//保存考官安排数据
export const invigilatearrange = (params) => {

  return post('/exam-arrange/invigilate-arrange', params).then(res => res.data);
}
//查询考生
export const studentsList = (params) => {
  return get('/exam/students', params).then(res => res.data);
}
//新增考生
export const addStudent = (params) => {
  return post('/exam/add-student', params).then(res => res.data);
}
//下载学生模板
export const importTpl = (params) => {
  return post('/exam/download-student-import-tpl', params).then(res => res.data);
}
//批量导入
export const importStudent = (params) => {
  return post('/exam/import-student', params).then(res => res.data);
}
//删除单个考生
export const delStudent = (params) => {
  return post('/exam/del-student', params).then(res => res.data);
}
//新增单个老师
export const addTeachers = (params) => {
  return post('/teachers', params).then(res => res.data);
}
// //智能排考
export const beginArrange = (params) => {
  return post('/exam-arrange/begin', params).then(res => res.data);
}
// //保存排考
export const storeArrange = (params) => {
  return post('/exam-arrange/store', params).then(res => res.data);
}
// //编辑考生
export const editStudent = (id,params) => {
  return post('/exam/update-student/' +id, params).then(res => res.data);
}
// //待考区保存
export const examWaiting = (params) => {
  return post('/exam/exam-waiting-area', params).then(res => res.data);
}
//智能排考回显
export const showArrange = (params) => {
  return get('/exam-arrange/show-arrange', params).then(res => res.data);
}
//单个考生详情
export const studentsDetails = (id,params) => {
  return get('/students/' + id,params).then(res => res.data);
}
//删除考试
export const deleteExam = (params) => {
  return post('/exam/delete', params).then(res => res.data);
}
//结束考试
export const finishExam = (params) => {
  return post('/exam/finish', params).then(res => res.data);
}
//发布成绩
export const sendResult = (params) => {
  return post('/exam/send-result', params).then(res => res.data);
}
//成绩查询
export const detailResult = (params) => {
  return get('/exam-results/detail/' + params.id, params).then(res => res.data);
}

/**
 * 统计分析
 */

//成绩查询
export const getSubjectScores = (params) => {
  return get('/statistics/course', params).then(res => res.data);
}
//成绩查询详情
export const getSubjectScoreDetail = (params) => {
  return get('/statistics/course-details', params).then(res => res.data);
}
//考生成绩统计
export const getStudentScore = (params) => {
  return get('/statistics/student-score', params).then(res => res.data);
}
//考生成绩查询详情
export const getStudentScoreDetail = (params) => {
  return get('/statistics/student-details', params).then(res => res.data);
}
//根据考试获取考生
export const getStudentByExamId = (params) => {
  return get('/statistics/getStudentByExamId', params).then(res => res.data);
}
//考生成绩分析
export const getStudentAnalysis = (params) => {
  return get('/statistics/student-analysis', params).then(res => res.data);
}
//单次考试成绩分析
export const singleExamAnalysis = (params) => {
  return get('/statistics/singleExamAnalysis', params).then(res => res.data);
}
//项目成绩趋势
export const subjectLine = (params) => {
  return get('/statistics/subjectLine', params).then(res => res.data);
}
//考站成绩分析
export const stationAnalysis = (params) => {
  return get('/statistics/stationAnalysis', params).then(res => res.data);
}
//考站成绩详情
export const stationDetails = (params) => {
  return get('/statistics/stationDetails', params).then(res => res.data);
}
//考核点分析
export const standardAnalysis = (params) => {
  return get('/statistics/standardAnalysis', params).then(res => res.data);
}
//考核点详情
export const standardDetails = (params) => {
  return get('/statistics/standardDetails', params).then(res => res.data);
}

//教学成绩分析
export const teacherAnalysis = (params) => {
  return get('/statistics/teacherAnalysis', params).then(res => res.data);
}
//班级成绩分析
export const teacherClassAnalysis = (params) => {
  return get('/statistics/teacherClassAnalysis', params).then(res => res.data);
}
//班级成绩分析
export const teacherClassDetail = (params) => {
  return get('/statistics/teacherClassDetail', params).then(res => res.data);
}

//班级成绩分析
export const studentAllScore = (params) => {
  return get('/statistics/studentAllScore', params).then(res => res.data);
}
//理论考试列表
export const getTheoryList = (params) => {
  return get('/theory/index', params).then(res => res.data);
}
//理论考试
export const getTheory = (id,params) => {
  return get('/theory/show/'+id,params).then(res => res.data);
}
//理论考试新增
export const addTheory = (params) => {
  return post('/theory/store',params).then(res => res.data);
}
//理论考试修改
export const updateTheory = (id,params) => {
  return put('/theory/update'+id,params).then(res => res.data);
}
//理论考试删除
export const deleteTheory = (id) => {
  return destroy('/theory/'+id).then(res => res.data);
}
// 理论考试学生列表
export const studentList = (params) => {
  return get('/theory/studentList', params).then(res => res.data);
}// 试卷列表
export const getExamPaper = (params) => {
  return get('/theory/examquestion', params).then(res => res.data);
}
// 预览试卷
export const paperView = (id,params)=>{
  return get('theory/paperView/'+id,params).then(res=>res.data)
}

export const autoquestion = (id,params)=>{
  return get('theory/autoquestion',params).then(res=>res.data)
}
export const studentscore = (id,params)=>{
  return get('theory/studentscore/'+id,params).then(res=>res.data)
}
export const getQuestionList = (params)=>{
  return get('theory/getQuestionList',params).then(res=>res.data)
}
export const getViewQuestion = (id)=>{
  return get('theory/getViewQuestion/'+id).then(res=>res.data)
}
export const autoexam = (params)=>{
  return post('theory/autoexam',params).then(res=>res.data)
}
//删除试卷
export const deletePaper = (id) => {
  return destroy('/theory/paper/'+id).then(res => res.data);
}




// WEBPACK FOOTER //
// ./src/restful/api.js